import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

function withNoCacheHeaders() {
  return {
    ...withAuthHeaders(),
    'Cache-Control': 'no-cache, no-store, max-age=0',
    Pragma: 'no-cache',
    Expires: '0',
  };
}

export const dashboardApi = {
  async listSummary(options = {}) {
    const { bustCache = false } = options;

    const response = await apiClient.get('/dashboard/summary', {
      headers: withNoCacheHeaders(),
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },
};

export function resolveDashboardApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to load dashboard data.');
}
